var cache = {};

require('setimmediate');

module.exports = function (work, id) {
  if (!cache[id]) {
    cache[id] = work;
    setImmediate(function () {
      delete cache[id];
      work();
    });
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/nextTick.js
 ** module id = 9
 ** module chunks = 0
 **/